module.exports = __webpack_public_path__ + "img/knowBtn.4667b922.png";